// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__K3w0P","left":"Hero_left__BLn+J","talk":"Hero_talk__kfuBu","btn_group":"Hero_btn_group__8KhQU"};